var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftLeanTo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 9L40.7857 3.28571L38.1429 2.14286L37.0876 1.68655C36.0745 1.24845 34.9255 1.24845 33.9124 1.68655L17 9",
    stroke: "#8A8A8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18L13.4243 12.6753C14.4305 12.2441 15.5695 12.2441 16.5757 12.6753L17 12.8571",
    stroke: "#8A8A8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 30C18.5 30.2761 18.2761 30.5 18 30.5C17.7239 30.5 17.5 30.2761 17.5 30L18.5 30ZM18.5 8L18.5 30L17.5 30L17.5 8L18.5 8Z",
    fill: "#8A8A8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 30C3.5 30.2761 3.27614 30.5 3 30.5C2.72386 30.5 2.5 30.2761 2.5 30L3.5 30ZM3.5 17L3.5 30L2.5 30L2.5 17L3.5 17Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLeanTo);
export default __webpack_public_path__ + "static/media/left-lean-to.b0f7c0bdb7634b4641e538c055f5bba9.svg";
export { ForwardRef as ReactComponent };